// ─────────────────────────────────────────────────────────────────────────────
// QUOTEMYBODYWORK — Firebase Config
// ─────────────────────────────────────────────────────────────────────────────
// HOW TO SET UP:
// 1. Go to https://console.firebase.google.com
// 2. Create a project called "quotemybodywork"
// 3. Add a Web app — copy the firebaseConfig object below
// 4. Enable Authentication → Email/Password
// 5. Enable Firestore Database (start in production mode)
// 6. Enable Storage (for photo uploads)
// 7. Replace the placeholder values below with your real config
// ─────────────────────────────────────────────────────────────────────────────

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCPATWZ3LsjWKDtySEdrm0lmZr3rBISCMs",
  authDomain: "quotemybodywork.firebaseapp.com",
  projectId: "quotemybodywork",
  storageBucket: "quotemybodywork.firebasestorage.app",
  messagingSenderId: "326234674134",
  appId: "1:326234674134:web:45847cf30de119373c0a77",
  measurementId: "G-316XG2KBJ1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
